<template>
	<path
		id="Vector"
		d="M3 14.259L3 1.5C3 1.22385 3.22385 1 3.5 1H12.5C12.7762 1 13 1.22385 13 1.5L13 14.259L8.75581 11.7832L8.25194 12.647L8.7558 11.7832C8.28876 11.5107 7.71124 11.5107 7.24419 11.7832L7.74806 12.647L7.24419 11.7832L3 14.259ZM3 14.259L2 14.259L3 14.259L3.46576 15.0574L3 14.259Z"
		stroke="#E2E2E2"
		stroke-width="2"
	/>
</template>
